import { render } from "./Calendario.vue?vue&type=template&id=4d227e50&scoped=true&ts=true"
import script from "./Calendario.vue?vue&type=script&lang=ts"
export * from "./Calendario.vue?vue&type=script&lang=ts"

import "./Calendario.vue?vue&type=style&index=0&id=4d227e50&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1764364635178909029/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d227e50"]])

export default __exports__